"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.search");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.applyFilter = applyFilter;
exports.applyPaging = applyPaging;
exports.pagingAsyncIterator = pagingAsyncIterator;
exports.FilterOperations = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

require("regenerator-runtime/runtime");

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _awaitAsyncGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/awaitAsyncGenerator"));

var _wrapAsyncGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/wrapAsyncGenerator"));

var FilterOperations;
exports.FilterOperations = FilterOperations;

(function (FilterOperations) {
  FilterOperations["BLANK"] = "BLANK";
  FilterOperations["NOTBLANK"] = "!BLANK";
  FilterOperations["LT"] = "LT";
  FilterOperations["LE"] = "LE";
  FilterOperations["GT"] = "GT";
  FilterOperations["GE"] = "GE";
  FilterOperations["EQ"] = "EQ";
  FilterOperations["NOTEQ"] = "!EQ";
  FilterOperations["BETWEEN"] = "BETWEEN";
  FilterOperations["NOTBETWEEN"] = "!BETWEEN";
  FilterOperations["IN"] = "IN";
  FilterOperations["NOTIN"] = "!IN";
})(FilterOperations || (exports.FilterOperations = FilterOperations = {}));

function applyFilter(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (options.orderBy) {
    url.searchParams.append('orderBy', options.orderBy);
  }

  if (options.search) {
    url.searchParams.append('search', options.search);
  }

  if (options.searchBy) {
    url.searchParams.append('searchBy', options.searchBy);
  }

  if ((0, _filter.default)(options)) {
    url.searchParams.append('filter', (0, _stringify.default)((0, _filter.default)(options)));
  }
}

function applyPaging(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (options.startIndex) {
    url.searchParams.append('startIndex', options.startIndex.toString());
  }

  if (options.pageIndex) {
    url.searchParams.append('pageIndex', options.pageIndex.toString());
  }

  if (options.pageNumber) {
    url.searchParams.append('pageNumber', options.pageNumber.toString());
  }

  if (options.itemsPerPage) {
    url.searchParams.append('itemsPerPage', options.itemsPerPage.toString());
  }
}

function pagingAsyncIterator(_x) {
  return _pagingAsyncIterator.apply(this, arguments);
}

function _pagingAsyncIterator() {
  _pagingAsyncIterator = (0, _wrapAsyncGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(request) {
    var startIndex, response, _iterator, _step, item;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            startIndex = 1;

          case 1:
            if (!startIndex) {
              _context.next = 25;
              break;
            }

            _context.next = 4;
            return (0, _awaitAsyncGenerator2.default)(request(startIndex));

          case 4:
            response = _context.sent;
            _iterator = (0, _createForOfIteratorHelper2.default)(response.items);
            _context.prev = 6;

            _iterator.s();

          case 8:
            if ((_step = _iterator.n()).done) {
              _context.next = 14;
              break;
            }

            item = _step.value;
            _context.next = 12;
            return item;

          case 12:
            _context.next = 8;
            break;

          case 14:
            _context.next = 19;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](6);

            _iterator.e(_context.t0);

          case 19:
            _context.prev = 19;

            _iterator.f();

            return _context.finish(19);

          case 22:
            if (response.nextLink) {
              startIndex = response.startIndex + response.itemsPerPage;
            } else {
              startIndex = 0;
            }

            _context.next = 1;
            break;

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 16, 19, 22]]);
  }));
  return _pagingAsyncIterator.apply(this, arguments);
}
